import { render, staticRenderFns } from "./DailyFerryCopyForm.vue?vue&type=template&id=1c4d69a7"
import script from "@/controllers/custom/daily_ferry/daily-ferry-copy-form.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/daily_ferry/daily-ferry-copy-form.js?vue&type=script&lang=js&external"
import style0 from "./DailyFerryCopyForm.vue?vue&type=style&index=0&id=1c4d69a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports